
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/signal/signal-rules",
      function () {
        return require("private-next-pages/docs/signal/signal-rules.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/signal/signal-rules"])
      });
    }
  